export default __webpack_public_path__ + "static/media/meta-ild-exit-label.fa032837.jpg";